import { RootState } from '../store'

export const invoicesSelector = (state: RootState) => {
  const { invoices } = state

  return invoices
}

export const selectedCargosForInvoiceSelector = (state: RootState) => {
  const { selectedCargosForInvoice } = state.invoices
  return selectedCargosForInvoice
}

export const isVisibleDetachCargosModalSelector = (state: RootState) => {
  const { isVisibleDetachCargosModal } = state.invoices
  return isVisibleDetachCargosModal
}

export const isVisibleDeleteCargosModalSelector = (state: RootState) => {
  const { isVisibleDeleteCargosModal } = state.invoices
  return isVisibleDeleteCargosModal
}
